import { Session } from '@kaizenplatform/hugot-entity';

import HttpClient from '../../adapter/HttpClient';

class SessionWebApi {
  private httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public signIn = async ({ email, password }: { email: string; password: string }): Promise<Session> => {
    let response;
    try {
      response = await this.httpClient.post('/authentication_token', {
        email,
        password,
      });
    } catch (err) {
      // TEMP: Refactor to be switched messages with error response.
      throw new Error(`メールアドレスかパスワードが間違っています。 (${err.message})`);
    }

    const json = await response.data;

    const authenticationToken = json['token'];
    const refreshToken = json['refresh_token'];

    return Session.fromJSON({ authenticationToken, refreshToken });
  };

  public signOut = async (session: Session): Promise<void> => {
    await this.httpClient.delete('/authentication_token/refresh', {
      data: {
        token: session.refreshToken,
      },
    });
  };

  public refresh = async (session: Session): Promise<Session> => {
    const response = await this.httpClient.post('/authentication_token/refresh', {
      token: session.refreshToken,
    });

    const json = await response.data;

    const authenticationToken = json['token'];
    const refreshToken = json['refresh_token'];

    return Session.fromJSON({ authenticationToken, refreshToken });
  };
}

export default SessionWebApi;
